import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';

@Component({
    selector: 'app-password-compliance',
    templateUrl: './shared-password-compliance.component.html',
    styleUrls: ['./shared-password-compliance.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedPasswordComplianceComponent extends BaseComponent implements OnInit {

    @Input()
    control: AbstractControl;

    constructor(protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    get errors(): ValidationErrors {
        return this.control.errors;
    }

    ngOnInit(): void {
        this.watch$ = this.control.valueChanges.pipe(
            tap(() => this.cdr.markForCheck())
        );
    }

}
